import React from "react";
import Footer from "./Footer";
import Header from "./Header";

const Support_create_ticket = () => {
  return (
    <div>
      <Header>
        <div className="content">
          <div class="mob_nav">
            <div class="row">
              <div class="col">
                <div class=" d-flex justify-content-start ">
                  <a href="javascript:window.history.back();" class="">
                    <i class="bi bi-arrow-left"></i>
                  </a>
                  <h2>Create Ticket</h2>
                </div>
              </div>
            </div>
          </div>

          <div class="row justify-content-between desk_nav">
            <div class="col-12 col-md-4 ">
              <div class="d-flex">
                <a href="javascript:window.history.back();" class="back_btn">
                  <i class="bi bi-arrow-90deg-left"></i>
                </a>
                <h2>Create Ticket</h2>
              </div>
            </div>
            <div class="col-12 col-md-4 mb-3 text-end"></div>
          </div>

          <div class="row ">
            <div class="col-12 col-md-6">
              <div class="card">
                <div class="card-body">
                  <div class="row">
                    <div class="col-12 col-md-6 mb-3">
                      <label for="email" class="form-label">
                        Category:
                      </label>
                      <select class="form-select">
                        <option>Select</option>
                        <option value="Pickup & Delivery">
                          Pickup & Delivery
                        </option>
                        <option value="Shipment NDR & RTO">
                          Shipment NDR & RTO
                        </option>
                        <option value="shipment-dispute">
                          Shipment Dispute
                        </option>
                        <option value="finance">Finance</option>
                        <option value="kyc-bank-verification">
                          KYC & Bank Verification
                        </option>
                        <option value="international-shipping">
                          International Shipping
                        </option>
                        <option value="technical-support">
                          Technical Support
                        </option>
                        <option value="billing-taxation">
                          Billing & Taxation
                        </option>
                        <option value="claims">Claims</option>
                        <option value="others">Others</option>
                      </select>
                    </div>
                    <div class="col-12 col-md-6 mb-3">
                      <label for="email" class="form-label">
                        Sub Category:
                      </label>
                      <select class="form-select">
                        <option>Select</option>
                        <option>
                          check pdf atached for all main and sub support
                          categories
                        </option>
                      </select>
                    </div>
                    <div class="col-12 col-md-12 mb-3">
                      <label for="email" class="form-label">
                        Subject:
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        id="text"
                        placeholder="Enter Subject"
                      />
                    </div>
                    <div class="col-12 col-md-12 mb-3">
                      <label for="email" class="form-label">
                        Shipment:
                      </label>
                      <div>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="radio"
                            name="inlineRadioOptions"
                            id="inlineRadio1"
                            value="option1"
                            checked
                          />
                          <label class="form-check-label" for="inlineRadio1">
                            Single
                          </label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="radio"
                            name="inlineRadioOptions"
                            id="inlineRadio2"
                            value="option2"
                          />
                          <label class="form-check-label" for="inlineRadio2">
                            Multiple
                          </label>
                        </div>
                      </div>
                      <div class="mb-3">
                        <input
                          type="text"
                          class="form-control"
                          id="text"
                          placeholder="Enter shipment number"
                        />
                      </div>
                      <div class="mb-3">
                        <textarea
                          class="form-control"
                          rows="5"
                          id="comment"
                          name="text"
                          placeholder="Enter AWB number. One in one row"
                        ></textarea>
                      </div>
                    </div>
                    <div class="col-12 col-md-12 mb-3">
                      <label for="email" class="form-label">
                        Details:
                      </label>
                      <textarea
                        class="form-control"
                        rows="5"
                        id="comment"
                        name="text"
                        placeholder="Enter details"
                      ></textarea>
                    </div>
                    <div class="col-12 col-md-12 mb-3">
                      <a href="#" class="btn btn-primary">
                        Create Ticket
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-4 px-5">
              {/* <!-- <img src="assets/images/support.png" class="img-fluid" style="max-height: 200px;" /> --> */}
              <h4>Need Help? We're Here for You!</h4>
              <p>
                We understand that sometimes you might need a little assistance,
                and that's what our support team is here for. If you're facing
                any issues, have questions, or need any form of help regarding
                our services, don't hesitate to reach out to us through this
                support ticket form.
              </p>
              <p>
                Once you submit your ticket, our dedicated support team will get
                to work and strive to resolve your issue as quickly as possible.
                You can track the status of your ticket and communicate directly
                with our team.
              </p>
              <div class="text-center border border-dark rounded-3 p-3 m-auto mb-3">
                <p class="fw-300 m-0">Reach Us</p>
                <h3 class="text-black">
                  <div>
                    <a
                      href="callto:+91123456789"
                      data-bs-toggle="tooltip"
                      data-bs-original-title="Call to Support"
                    >
                      <i class="bi bi-headset"></i> +91123456789
                    </a>
                  </div>
                  <div class="mt-2">
                    <a
                      href="mailto:hello@kalpcargo.com"
                      data-bs-toggle="tooltip"
                      data-bs-original-title="Mail Us"
                    >
                      <i class="bi bi-envelope"></i> hello@kalpcargo.com
                    </a>
                  </div>
                </h3>
              </div>
            </div>
          </div>
        </div>
      </Header>
      <Footer />
    </div>
  );
};

export default Support_create_ticket;
